// extracted by mini-css-extract-plugin
module.exports = {"modal":"ContactsModal_modal__2wpxO","body":"ContactsModal_body__ukOSv","item":"ContactsModal_item__32M0S","link":"ContactsModal_link__1I3Up"};